import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { installMetaPixelBase } from "./utils/metaPixel";

// Meta Pixel base code — injected once into the global <head> (init + PageView)
installMetaPixelBase();

// Meta domain verification tag (added once to the global <head>)
if (!document.querySelector('meta[name="facebook-domain-verification"]')) {
  const meta = document.createElement("meta");
  meta.name = "facebook-domain-verification";
  meta.content = "ahyc5uxycqx5tn9cst2bg6nu7gmu45";
  document.head.appendChild(meta);
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-387" data-mp="2ozs9s7vydhmg" />);
}